module.exports = __webpack_public_path__ + "assets/img/btn-back-074834a9.png";